import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'react-bootstrap';
import UserListTable from './UserListTable';

export default class UserList extends Component {
  render() {
    return (
      <div>
        <LinkContainer to="/users/create">
          <Button>Create User</Button>
        </LinkContainer>
        <UserListTable />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/user/UserList.js